import React, { useState } from 'react'
import {
  Grid,
  TextField,
  Typography,
  Button,
  Link,
  Snackbar,
  Alert,
  InputAdornment,
  IconButton,
  Container,
} from '@mui/material'
import laptopImg from '../Asset/images/laptop.png'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

import axios from 'axios'
import config from '../config'
import { useHistory } from 'react-router-dom'

function LoginForm(props) {
  const history = useHistory()
  const [showPassword, setShowPassword] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)
  const [loginData, setLoginData] = useState({
    username: '',
    password: '',
    device_type: 'web',
  })

  const handleClose = () => {
    setOpenAlert(false)
  }

  const handleShowPassword = () => {
    setShowPassword((show) => !show)
  }

  const onSubmit = () => {
    axios
      .post(`${config.url}/auth/token`, loginData, config.token)
      .then((res) => {
        const paramJson = {
          username: loginData.username,
          token: res.data.access_token,
        }
        localStorage.setItem('access_token', JSON.stringify(paramJson))
        history.push('/')
      })
      .catch((e) => {
        setOpenAlert(true)
      })
  }

  return (
    <Container maxWidth='xl'>
      <Grid container sx={{ mt: '30px', mb: '40px' }}>
        <Grid item xs={12}>
          <Typography variant='h5' sx={{ textAlign: 'center' }}>
            Log in to MCASH
          </Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          {/* <Grid item sm={12} sx={{ paddingBottom: '100px' }} /> */}
          <Grid item xs={12} sx={{ pb: '30px', pt: '50px' }}>
            <Typography>Username or Email</Typography>
            <TextField
              id='outlined-basic'
              variant='outlined'
              label='Username'
              size='small'
              fullWidth
              required
              onChange={(e) =>
                setLoginData({ ...loginData, username: e.target.value })
              }
            />
          </Grid>
          <Grid item xs={12} sx={{ paddingBottom: '30px' }}>
            <Typography>Password</Typography>
            <TextField
              id='outlined-basic'
              variant='outlined'
              type={showPassword ? 'text' : 'password'}
              label='Password'
              required
              size='small'
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton onClick={handleShowPassword} edge='end'>
                      {showPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(e) =>
                setLoginData({ ...loginData, password: e.target.value })
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant='contained'
              fullWidth
              sx={{ background: '#cc0600' }}
              onClick={() => onSubmit()}
            >
              Log In
            </Button>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: '30px' }}>
            <Link href='/register' underline='none' color='#228B22'>
              <Typography>Register</Typography>
            </Link>
            <Link href='/forgot-password' underline='none' color='#228B22'>
              <Typography>Forgot Password</Typography>
            </Link>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          lg={6}
          sx={{
            display: {
              xs: 'none',
              lg: 'block',
            },
          }}
        >
          <Grid item sm={12}>
            <img src={laptopImg} alt='laptop' />
          </Grid>
        </Grid>
        <Snackbar
          open={openAlert}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert severity='warning'>Wrong Username or Password</Alert>
        </Snackbar>
      </Grid>
    </Container>
  )
}

export default LoginForm
